import React from 'react';
import HeaderComponent from '../../commons/header/headerComponent';
import PreloaderComponent from '../../commons/preloader/preloaderComponent';
import { Link } from 'react-router-dom';
import FooterComponent from '../../commons/footer/footerComponent';
import { useTranslation } from 'react-i18next';

const PayReturnView = ({ success, purchase, isLoading }) => {
    const { t } = useTranslation();

    const showSuccess = success && purchase && purchase.status === 'paid';
    const showCancelled =
        !success || (success && purchase && purchase.status === 'cancelled');

    return (
        <div>
            <HeaderComponent />

            {(isLoading || (!showCancelled && !showSuccess)) && (
                <PreloaderComponent />
            )}

            {showSuccess && (
                <div className="container">
                    <h3>{t('payReturn.successTitle')}</h3>
                    <p>{t('payReturn.successReceipt')}</p>

                    <p>{t('payReturn.successMembership')}</p>

                    <p>{t('payReturn.successPickup')}</p>

                    <Link className="btn btn-success success" to={`/member`}>
                        {t('common.backHome')}
                    </Link>
                </div>
            )}

            {showCancelled && (
                <div className="container">
                    <h3>{t('payReturn.cancelledTitle')}</h3>
                    <p>{t('payReturn.cancelledBody')}</p>
                    <Link className="btn btn-success success" to={`/member`}>
                        {t('common.backHome')}
                    </Link>
                </div>
            )}
            <FooterComponent />
        </div>
    );
};

export default PayReturnView;
